require('./globalAllPositionsSummary.scss');

// @ vendors
const React = require('react');
const Immutable = require('immutable');
const PropTypes = require('prop-types');
// @commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @ components
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @constants
const { EURO_TEXT } = require('constants/index');
const { CREDIT } = require('constants/flagBasedFeatures');


class GlobalPositionAllPositionsSummary extends React.Component {

    calculateFinalEURAmount (immAmounts, keepSign) {
        let amount = 0;

        if (immAmounts) {
            amount = immAmounts.map(amountObject => {
                if (amountObject.get('currency') !== EURO_TEXT) {
                    /**
                     * Here we should make currency convertion
                     */
                    return amountObject.get('amount') * 1;
                }
                return amountObject.get('amount');
            }).reduce((prev, next) => prev + next );
        }

        return Immutable.fromJS({
            amount: keepSign ? amount : Math.abs(amount),
            currency: EURO_TEXT
        });
    }

    render() {
        const { immCards, immAccounts , immSavings, immWalletSummarization, immWealthRoboValues, immLoans, isBalanceDrawn, wealthDataFF, isNewPgWealthAllowed } = this.props;
        
        const accountBalance = isBalanceDrawn
            ? immAccounts.get('balanceDrawnForGlobalPosition')
            : immAccounts.get('balanceForGlobalPosition')

        const savingsAmounts = accountBalance.concat(
            immCards.get('ecard').get('availableBalanceForPG'),
            immSavings.get('totalAvailableBalance')
        );
        const investmentsAmounts = immWalletSummarization.getIn(['values', 'balance']).concat(
            immWalletSummarization.getIn(['futures', 'balance']),
            immWalletSummarization.getIn(['plans', 'balance']),
            immWalletSummarization.getIn(['funds', 'balance']),
            immWealthRoboValues.get('balance')
        );
        const loansBalance = immLoans.get('loansBalanceForPG');
        const mortgagesBalance = immLoans.get('mortgagesBalanceForPG');
        let cardsBalance = immCards.getIn(['credit', 'balanceDrawnForPG']);

        // we need to invert the value of cardsBalance to match the negative value of loans, mortgages, etc
        cardsBalance = cardsBalance.updateIn([0, 'amount'], amount => amount * -1);
        const financingAmounts = loansBalance.concat(cardsBalance).concat(mortgagesBalance);
        let savingsAmountObject = this.calculateFinalEURAmount(savingsAmounts, true);
        let investmentAmountObject = this.calculateFinalEURAmount(investmentsAmounts, true);
        const cardsAmountObject = this.calculateFinalEURAmount(financingAmounts, false);

        let investmentSavingsSum = savingsAmountObject.get('amount');
        if(isNewPgWealthAllowed){
            if(wealthDataFF && wealthDataFF.get('total')){
                investmentSavingsSum = parseFloat(savingsAmountObject.get('amount')) + parseFloat(wealthDataFF.get('total'));
            } 
        } else {
            investmentSavingsSum = investmentAmountObject.get('amount') + savingsAmountObject.get('amount');
        }

        const investmentSavingsSumObject = {
            'amount': investmentSavingsSum,
            'currency': investmentAmountObject.get('currency')
        }
        const plainCardsAmountObject = getPlainAmountObject(cardsAmountObject);

        return (
            <section className="glb-all-position-summary">
                <div className="glb-all-position-summary__title">
                    <FormattedText value="myGlobalPosition-myGlobalPosition_allmypositions"/>
                </div>
                <div className="glb-all-position-summary__content">
                    <div className="glb-all-position-summary__totalbalance-section">
                        <FormattedText className="glb-all-position-summary__statement" value="myGlobalPosition-myGlobalPosition_accounts"/>
                        <OneLineSymbolAmount
                            amountObject={investmentSavingsSumObject}
                            className="global-position-total-balance__amount"
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(investmentSavingsSumObject, false)}
                        />
                    </div>
                </div>
                <FeatureTogglingRender notAllowedProductKey={CREDIT} >
                    <div className="glb-all-position-summary__content">
                        <div className="glb-all-position-summary__totalbalance-section">
                            <FormattedText className="glb-all-position-summary__statement" value="myGlobalPosition-myGlobalPosition_totalfinance"/>
                            <OneLineSymbolAmount
                                amountObject={plainCardsAmountObject}
                                className="global-position-total-balance__amount"
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainCardsAmountObject, false)}
                        />
                        </div>
                    </div>
                </FeatureTogglingRender>
            </section>
        );
    }
}

GlobalPositionAllPositionsSummary.propTypes = {
    immCards: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immSavings: PropTypes.object.isRequired,
    immWalletSummarization: PropTypes.object,
    immWealthRoboValues: PropTypes.object,
    immLoans: PropTypes.object
};

module.exports = GlobalPositionAllPositionsSummary;
